module.exports = __webpack_public_path__ + "static/media/28.0d74e884.png";